import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useLoginContext } from './LoginContext.jsx';
import notify from './Nots.jsx';

const ProtectedRoute = () => {
    const { isLoggedIn, userInfo } = useLoginContext();
    const [redirect, setRedirect] = useState(null);
    const location = useLocation();

    useEffect(() => {
        console.log('ProtectedRoute useEffect', {
            isLoggedIn,
            userInfo,
            redirect,
            pathname: location.pathname,
        });

        const notifyDeferred = (message, type) => {
            setTimeout(() => {
                console.log('Notifying:', { message, type });
                notify(message, type);
            }, 0);
        };

        if (isLoggedIn === undefined || isLoggedIn === null) {
            console.log('ProtectedRoute: Still loading');
            return;
        }

        if (!isLoggedIn) {
            if (location.pathname !== '/login') {
                notifyDeferred('Please log in to access this page.', 'error');
                setRedirect('/login');
            }
            return;
        }

        if (!userInfo || !userInfo.accessToken) {
            if (location.pathname !== '/login') {
                notifyDeferred('Invalid user data. Please log in again.', 'error');
                localStorage.clear();
                setRedirect('/login');
            }
            return;
        }

        setRedirect(null);
    }, [isLoggedIn, userInfo, location.pathname]);

    if (isLoggedIn === undefined || isLoggedIn === null) {
        console.log('ProtectedRoute: Rendering loading state');
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
                <p className="text-lg font-medium text-gray-700">Loading...</p>
            </div>
        );
    }

    if (!isLoggedIn && location.pathname !== '/login') {
        console.log('ProtectedRoute: Immediate redirect to /login');
        return <Navigate to="/login" replace />;
    }

    if (redirect && redirect !== location.pathname) {
        console.log('ProtectedRoute: Redirecting to', redirect);
        return <Navigate to={redirect} replace />;
    }

    console.log('ProtectedRoute: Rendering Outlet');
    return <Outlet />;
};

export default ProtectedRoute;